import { useRequest } from 'ahooks';
import { Button, Form, Input, message, Modal, Select, Table } from 'antd';
import LocaleContext from 'locales';
import React, { useContext, useState } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { getUser } from 'services/websocket/users';

/**
 * 컴포넌트: 사용자 검색
 * @param {namePath} visible Modal.visible
 * @param {function} onSelected 사용자 선택 후 호출할 콜백 함수
 * @returns ReactNode
 */
export default function UserSearch(props) {
  const { visible, onSelected } = props;

  // hooks
  const { locale } = useContext(LocaleContext);
  const fetchUsers = useRequest(getUser, { manual: true });

  // states
  const [selectedUser, setSelectedUser] = useState(undefined); // 선택한 사용자 정보
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // Table 선택 rowKeys

  // refs
  const [searchForm] = Form.useForm();

  // 모달 초기화
  const modalInit = () => {
    searchForm.resetFields();
    fetchUsers.mutate([]);
    setSelectedUser(undefined);
    setSelectedRowKeys([]);
  };

  // 모달 onCancel
  const onModalCancel = () => {
    onSelected(undefined);
    modalInit();
  };

  // 모달 okOK
  const onModalOk = () => {
    if (!selectedUser) {
      message.warning(locale.resource['txt-please-select']);
      return;
    }
    onSelected(selectedUser);
    modalInit();
  };

  // 검색 시
  const onSearch = async (values) => {
    fetchUsers.runAsync(values);
  };

  return (
    <Modal
      title={locale.resource['txt.select-user']}
      visible={visible}
      width={640}
      cancelText={locale.resource['txt.cancel']}
      okText={locale.resource['txt.select']}
      onCancel={onModalCancel}
      onOk={onModalOk}
      destoryOnClose
    >
      <Table
        title={() => (
          <Form form={searchForm} onFinish={onSearch} initialValues={{ type: 'name' }}>
            <Input.Group compact>
              <Form.Item name="type">
                <Select
                  style={{ width: 60 }}
                  getPopupContainer={(triggerNode) => triggerNode.parentElement.parentElement}
                  options={[
                    { label: locale.resource['txt.name'], value: 'name' },
                    { label: locale.resource['txt.id'], value: 'sAMAccountName' },
                  ]}
                />
              </Form.Item>

              <Form.Item
                name="value"
                rules={[{ required: true, message: locale.resource['txt.required-field'] }]}
              >
                <Input
                  placeholder={locale.resource['txt.search-user']}
                  style={{ width: 160 }}
                  autoFocus
                />
              </Form.Item>
              <Button
                htmlType="submit"
                icon={<AiOutlineSearch className="anticon" style={{ margin: '0 auto' }} />}
              />
            </Input.Group>
          </Form>
        )}
        size="small"
        rowKey="dn"
        dataSource={fetchUsers.data}
        loading={fetchUsers.loading}
        columns={[
          {
            title: locale.resource['txt.name'],
            dataIndex: 'userName',
            width: 160,
            ellipsis: true,
          },
          {
            title: locale.resource['txt.user-id'],
            dataIndex: 'sAMAccountName',
            width: 120,
          },
          { title: locale.resource['txt.department'], dataIndex: 'organization' },
        ]}
        rowSelection={{
          type: 'radio',
          selectedRowKeys,
          onChange: (keys, rows) => {
            setSelectedRowKeys(keys);
            setSelectedUser(rows[0]);
          },
        }}
      />
    </Modal>
  );
}
